import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

import { InputCustomField } from './InputCustomField.entity';

export class InputRa<T extends EMode = EMode.entity> {
  /** Alias: code */
  code?: number;
  /** Alias: datum */
  datum?: string;
  /** Alias: rechnungNummer */
  rechnungNummer?: number;
  /** Alias: sdObjMemberCode */
  sdObjMemberCode?: number;
  /** Alias: faelligDatum */
  faelligDatum?: string;
  /** Alias: betrag */
  betrag?: number;
  /** Alias: mwstBetrag */
  mwstBetrag?: number;
  /** Alias: rMwstNeu */
  rMwstNeu?: number;
  /** Alias: bezehaltBetrag */
  bezehaltBetrag?: number;
  /** Alias: stornSumme */
  stornSumme?: number;
  /** Alias: mahnstufe */
  mahnstufe?: number;
  /** Alias: notiz */
  notiz?: string;
  /** Alias: skonto */
  skonto?: number;
  /** Alias: kostenstelle */
  kostenstelle?: number;
  /** Alias: frist */
  frist?: string;
  /** Alias: listFlag */
  listFlag?: number;
  /** Alias: dtaNummer */
  dtaNummer?: number;
  /** Alias: rechnungCode */
  rechnungCode?: number;
  /** Alias: benutzerCode */
  benutzerCode?: number;
  /** Alias: raSachkGesamt */
  raSachkGesamt?: number;
  /** Alias: raKostenstGesamt */
  raKostenstGesamt?: number;
  /** Alias: datev */
  datev?: string;
  /** Alias: kurs */
  kurs?: number;
  /** Alias: waehrungCode */
  waehrungCode?: number;
  /** Alias: waehrungDatum */
  waehrungDatum?: string;
  /** Alias: provision */
  provision?: number;
  /** Alias: buchungsDatum */
  buchungsDatum?: string;
  /** Alias: summe */
  summe?: number;
  /** Alias: lastschriftOk */
  lastschriftOk?: boolean;
  /** Alias: zahlungCode */
  zahlungCode?: number;
  /** Alias: bankkontoCode */
  bankkontoCode?: number;
  /** Alias: buchhaltungssperre */
  buchhaltungssperre?: boolean;
  /** Alias: dmsId */
  dmsId?: string;
  /** Alias: customFields */
  customFields?: InputCustomField<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<InputRa> = {
  code: {
    alias: 'code',
  },
  datum: {
    alias: 'datum',
  },
  rechnungNummer: {
    alias: 'rechnungNummer',
  },
  sdObjMemberCode: {
    alias: 'sdObjMemberCode',
  },
  faelligDatum: {
    alias: 'faelligDatum',
  },
  betrag: {
    alias: 'betrag',
  },
  mwstBetrag: {
    alias: 'mwstBetrag',
  },
  rMwstNeu: {
    alias: 'rMwstNeu',
  },
  bezehaltBetrag: {
    alias: 'bezehaltBetrag',
  },
  stornSumme: {
    alias: 'stornSumme',
  },
  mahnstufe: {
    alias: 'mahnstufe',
  },
  notiz: {
    alias: 'notiz',
  },
  skonto: {
    alias: 'skonto',
  },
  kostenstelle: {
    alias: 'kostenstelle',
  },
  frist: {
    alias: 'frist',
  },
  listFlag: {
    alias: 'listFlag',
  },
  dtaNummer: {
    alias: 'dtaNummer',
  },
  rechnungCode: {
    alias: 'rechnungCode',
  },
  benutzerCode: {
    alias: 'benutzerCode',
  },
  raSachkGesamt: {
    alias: 'raSachkGesamt',
  },
  raKostenstGesamt: {
    alias: 'raKostenstGesamt',
  },
  datev: {
    alias: 'datev',
  },
  kurs: {
    alias: 'kurs',
  },
  waehrungCode: {
    alias: 'waehrungCode',
  },
  waehrungDatum: {
    alias: 'waehrungDatum',
  },
  provision: {
    alias: 'provision',
  },
  buchungsDatum: {
    alias: 'buchungsDatum',
  },
  summe: {
    alias: 'summe',
  },
  lastschriftOk: {
    alias: 'lastschriftOk',
  },
  zahlungCode: {
    alias: 'zahlungCode',
  },
  bankkontoCode: {
    alias: 'bankkontoCode',
  },
  buchhaltungssperre: {
    alias: 'buchhaltungssperre',
  },
  dmsId: {
    alias: 'dmsId',
  },
  customFields: {
    alias: 'customFields',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputRaEntityDefinition: EntitiyDefinition<InputRa> = {
  local: {},
  remote: {
    queryName: '',
    fragmentName: 'InputRa',
    withPaginationWrapper: false,
  },
  fieldDefinitions: fields,
};
